import { render, staticRenderFns } from "./relatedProducts.vue?vue&type=template&id=f487061e&scoped=true&"
import script from "./relatedProducts.vue?vue&type=script&lang=js&"
export * from "./relatedProducts.vue?vue&type=script&lang=js&"
import style0 from "./relatedProducts.vue?vue&type=style&index=0&id=f487061e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f487061e",
  null
  
)

export default component.exports